import BaseManagementComponent from 'components/BaseManagementComponent'
import { useStore } from 'context/store'
import dayjs from 'dayjs'
import { observer } from 'mobx-react'
import { Button } from 'primereact/button'
import { Tag } from 'primereact/tag'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DATE_TIME_FORMAT } from 'utils/constants/datetime'
import { ProjectTag } from 'Models'
import ModalTag from './ModalTag'

const TagManagement = () => {
  const { t } = useTranslation()
  const {
    tagManagementStore: {
      handleFilterDataChange,
      loadingListing,
      deleteItem,
      listData: { data, meta },
    },
  } = useStore()

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedTag, setSelectedTag] = useState<ProjectTag | null>(null)

  const handleOpenCreateModal = () => {
    setSelectedTag(null)
    setModalVisible(true)
  }

  const handleOpenEditModal = (tag: ProjectTag) => {
    setSelectedTag(tag)
    setModalVisible(true)
  }

  return (
    <>
      <BaseManagementComponent
        dataSource={data}
        loading={loadingListing}
        actionColumns={[
          {
            key: 'edit',
            tooltip: t('Edit'),
            icon: <i className="isax-edit"></i>,
            action: (item) => handleOpenEditModal(item),
          },
          {
            key: 'delete',
            tooltip: t('Delete'),
            icon: <i className="isax-trash"></i>,
            showConfirm: {
              message: t('doyouwant', {
                action: t('Delete item', {
                  item: t('Tag'),
                }),
              }),
              header: t('confirmation', {
                action: t('Delete'),
              }),
            },
            action: (data) => {
              deleteItem(data._id)
            },
          },
        ]}
        columns={[
          {
            key: 'name',
            header: t('Tag Name'),
            body: (data) => (
              <Tag severity="warning" className="font-medium">
                {data.name}
              </Tag>
            ),
          },
          {
            key: 'assignedBranchCount',
            header: t('Assigned Branches'),
            width: '30%',
            body: (data) => data.assignedBranchCount ?? 0,
          },
          {
            key: 'createdAt',
            sortable: true,
            body: (data) =>
              data.createdAt
                ? dayjs(data.createdAt).format(DATE_TIME_FORMAT.FULL)
                : '-',
            header: t('Created At'),
            width: '30%',
          },
        ]}
        pagination={{
          ...meta,
        }}
        handleFilterDataChange={handleFilterDataChange}
        filterComponent={
          <div className="flex justify-content-between align-items-start mb-3">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 m-0">
                {t('Tag management')}
              </h1>
              <div className="text-sm text-gray-500 mt-1">
                {t(
                  'Manage tags assigned to branches (used as newsletter targeting groups)'
                )}
              </div>
            </div>
            <Button
              icon="isax isax-add"
              label={t('Add new', { item: t('Tag') })}
              onClick={handleOpenCreateModal}
            />
          </div>
        }
      />

      <ModalTag
        visible={modalVisible}
        onHide={() => setModalVisible(false)}
        tag={selectedTag}
      />
    </>
  )
}

export default observer(TagManagement)
